import { render, staticRenderFns } from "./creatGroupMore.vue?vue&type=template&id=47130ffe&scoped=true"
import script from "./creatGroupMore.vue?vue&type=script&lang=js"
export * from "./creatGroupMore.vue?vue&type=script&lang=js"
import style0 from "./creatGroupMore.vue?vue&type=style&index=0&id=47130ffe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47130ffe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47130ffe')) {
      api.createRecord('47130ffe', component.options)
    } else {
      api.reload('47130ffe', component.options)
    }
    module.hot.accept("./creatGroupMore.vue?vue&type=template&id=47130ffe&scoped=true", function () {
      api.rerender('47130ffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/groupBuy/groupGoods/creatGroupMore.vue"
export default component.exports